import { createContext } from "react";
const ThemeContext = createContext(void 0);
export {
  ThemeContext as default
};
